import { render, staticRenderFns } from "./ZakazkaPendingItems.vue?vue&type=template&id=9af7b534&"
import script from "./ZakazkaPendingItems.vue?vue&type=script&lang=ts&"
export * from "./ZakazkaPendingItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports